import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { featuredComics } from '@/mocks/comics';

const panelImages: Record<number, string[]> = {
  1: [
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20panel%20art%2C%20first%20panel%20of%20regeneration%20manhwa%2C%20dramatic%20city%20skyline%20scene%20with%20mysterious%20figure%20standing%20on%20rooftop%2C%20golden%20energy%20aura%2C%20moody%20atmosphere%20with%20deep%20navy%20blue%20sky%2C%20professional%20comic%20panel%20quality%2C%20clean%20line%20art%2C%20detailed%20background&width=1200&height=800&seq=read-1-1-1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20panel%20art%2C%20young%20man%20awakening%20with%20spiritual%20energy%20in%20modern%20apartment%2C%20blue%20and%20gold%20glowing%20effects%2C%20intense%20expression%2C%20detailed%20interior%20background%2C%20professional%20manhwa%20quality%2C%20dramatic%20lighting&width=1200&height=1000&seq=read-1-1-2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comic%20panel%2C%20flashback%20scene%20of%20ancient%20cultivation%20world%2C%20misty%20mountain%20peaks%2C%20floating%20islands%2C%20golden%20clouds%2C%20mystical%20atmosphere%2C%20vibrant%20color%20palette%2C%20detailed%20fantasy%20landscape&width=1200&height=900&seq=read-1-1-3&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20panel%2C%20young%20cultivator%20fighting%20shadow%20enemies%20in%20urban%20alleyway%2C%20dynamic%20martial%20arts%20pose%2C%20energy%20blast%20effects%2C%20dramatic%20night%20lighting%2C%20cinematic%20composition%2C%20intense%20action%20scene&width=1200&height=1100&seq=read-1-1-4&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20dialogue%20panel%2C%20close%20up%20of%20two%20characters%20having%20emotional%20conversation%2C%20soft%20warm%20lighting%2C%20intimate%20atmosphere%2C%20detailed%20facial%20expressions%2C%20webtoon%20style%20character%20art%2C%20romantic%20undertone&width=1200&height=850&seq=read-1-1-5&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20dramatic%20panel%2C%20villain%20character%20reveal%20in%20luxurious%20office%2C%20dark%20suit%2C%20sinister%20smile%2C%20opulent%20background%20with%20city%20view%20through%20window%2C%20high%20contrast%20lighting%2C%20powerful%20presence&width=1200&height=950&seq=read-1-1-6&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20final%20panel%2C%20protagonist%20standing%20victorious%20on%20hilltop%20overlooking%20modern%20city%20at%20sunset%2C%20warm%20golden%20hour%20light%2C%20hopeful%20expression%2C%20cinematic%20wide%20angle%20shot%2C%20inspiring%20atmosphere&width=1200&height=1000&seq=read-1-1-7&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cliffhanger%20panel%2C%20mysterious%20symbol%20appearing%20in%20sky%20above%20the%20city%2C%20ominous%20red%20glow%2C%20birds%20scattering%2C%20dramatic%20tension%2C%20professional%20comic%20art%2C%20impactful%20composition&width=1200&height=800&seq=read-1-1-8&orientation=portrait',
  ],
  2: [
    'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20panel%2C%20elegant%20wedding%20venue%20with%20cherry%20blossom%20decorations%2C%20bride%20in%20white%20dress%20entering%20hall%2C%20warm%20ambient%20lighting%2C%20romantic%20atmosphere%2C%20detailed%20background&width=1200&height=800&seq=read-2-1-1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20close-up%20panel%2C%20handsome%20groom%20in%20black%20tuxedo%20with%20cold%20expression%2C%20sharp%20jawline%2C%20intense%20gaze%2C%20formal%20wedding%20setting%2C%20dramatic%20lighting%2C%20manhwa%20art%20style&width=1200&height=900&seq=read-2-1-2&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20dialogue%20panel%2C%20bride%20and%20groom%20standing%20face%20to%20face%20at%20altar%2C%20tension%20in%20the%20air%2C%20soft%20focus%20background%2C%20emotional%20moment%2C%20beautiful%20wedding%20flowers%2C%20cinematic%20framing&width=1200&height=1000&seq=read-2-1-3&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20panel%2C%20couple%20having%20awkward%20first%20dinner%20together%20after%20wedding%2C%20luxurious%20dining%20room%2C%20candlelit%20table%2C%20subtle%20romantic%20tension%2C%20elegant%20interior%20design&width=1200&height=850&seq=read-2-1-4&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20emotional%20panel%2C%20female%20lead%20crying%20alone%20in%20bedroom%2C%20moonlight%20through%20window%2C%20poignant%20atmosphere%2C%20beautiful%20melancholic%20scene%2C%20soft%20cool%20tones%2C%20detailed%20character%20art&width=1200&height=950&seq=read-2-1-5&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20dramatic%20panel%2C%20male%20lead%20standing%20protectively%20in%20front%20of%20female%20lead%2C%20confrontation%20with%20antagonist%2C%20intense%20emotions%2C%20dynamic%20angle%2C%20dramatic%20shadows%2C%20powerful%20composition&width=1200&height=1000&seq=read-2-1-6&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20panel%2C%20couple%20sharing%20gentle%20moment%20in%20garden%20at%20golden%20hour%2C%20hands%20almost%20touching%2C%20warm%20sunset%20glow%2C%20romantic%20atmosphere%2C%20beautiful%20flowers%2C%20intimate%20scene&width=1200&height=900&seq=read-2-1-7&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cliffhanger%20panel%2C%20former%20lover%20appearing%20at%20the%20couple%20doorstep%20with%20luggage%2C%20shocked%20expressions%2C%20rainy%20night%20setting%2C%20dramatic%20tension%2C%20cinematic%20composition&width=1200&height=800&seq=read-2-1-8&orientation=portrait',
  ],
};

export default function ComicReadPage() {
  const { id, chapter } = useParams<{ id: string; chapter: string }>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id, chapter]);

  const comic = featuredComics.find((c) => c.id === Number(id));
  const chapterNum = Number(chapter) || 1;
  const comicId = Number(id);

  if (!comic) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen bg-background-50 pt-24 flex items-center justify-center">
          <div className="text-center">
            <span className="w-20 h-20 flex items-center justify-center mx-auto mb-4 text-foreground-300">
              <i className="ri-file-unknow-line text-5xl"></i>
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-2">漫画未找到</h2>
            <Link
              to="/category"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览其他漫画
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const hasPrev = chapterNum > 1;
  const hasNext = chapterNum < comic.chapters;
  const panels = panelImages[comicId] || panelImages[1];

  return (
    <>
      <Navbar />
      <main>
        <section className="bg-background-950 pt-20 md:pt-24 pb-4">
          <div className="w-full px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-3 flex-wrap">
              <Link to="/" className="hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">
                首页
              </Link>
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
              <Link to={`/comic/${comic.id}`} className="hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">
                {comic.title}
              </Link>
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
              <span className="text-primary-300 whitespace-nowrap">第{chapterNum}话</span>
            </nav>
            <div className="flex items-center justify-between">
              <div>
                <h1 className="font-heading text-lg md:text-xl font-bold text-background-50">
                  {comic.title} - 第{chapterNum}话
                </h1>
                <p className="text-foreground-400 text-xs mt-1">{comic.author} · 著</p>
              </div>
              <div className="flex items-center gap-2">
                <Link
                  to={`/comic/${comic.id}`}
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-800 text-background-200 rounded-full text-xs font-medium hover:bg-background-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-list-check text-sm"></i>
                  </span>
                  章节列表
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-200/70 py-8 md:py-12 min-h-screen">
          <div className="w-full max-w-2xl mx-auto px-4">
            <div className="flex items-center justify-between mb-8">
              {hasPrev ? (
                <Link
                  to={`/comic/${comic.id}/read/${chapterNum - 1}`}
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-50 border border-background-200/70 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-left-s-line"></i>
                  </span>
                  上一话
                </Link>
              ) : (
                <div></div>
              )}
              <span className="text-foreground-500 text-sm font-medium">{chapterNum} / {comic.chapters}</span>
              {hasNext ? (
                <Link
                  to={`/comic/${comic.id}/read/${chapterNum + 1}`}
                  className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-50 border border-background-200/70 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  下一话
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </Link>
              ) : (
                <div></div>
              )}
            </div>

            <div className="flex flex-col gap-0 bg-background-50 rounded-2xl overflow-hidden shadow-sm">
              {panels.map((imgSrc, idx) => (
                <div key={idx} className="relative">
                  <img
                    src={imgSrc}
                    alt={`${comic.title} 第${chapterNum}话 - 第${idx + 1}页`}
                    title={`${comic.title} 第${chapterNum}话第${idx + 1}页 - 尾巴漫画网`}
                    className="w-full h-auto"
                  />
                </div>
              ))}
            </div>

            <div className="flex items-center justify-between mt-8 mb-10">
              {hasPrev ? (
                <Link
                  to={`/comic/${comic.id}/read/${chapterNum - 1}`}
                  className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-left-s-line"></i>
                  </span>
                  上一话
                </Link>
              ) : (
                <div></div>
              )}
              <Link
                to={`/comic/${comic.id}`}
                className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-list-check"></i>
                </span>
                返回详情
              </Link>
              {hasNext ? (
                <Link
                  to={`/comic/${comic.id}/read/${chapterNum + 1}`}
                  className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  下一话
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </Link>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}